import React from 'react';
import { useState } from "react";
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import setSelectAllButtonAction from '../../redux/actions/searchReferenceActions/actionSelectAllButton';
import { useDispatch } from 'react-redux'

const SelectAllButton = () => {

    const [allClickedCount, setAllClickedCount] = useState(false);
    const dispatch = useDispatch();

    React.useEffect(() => {
         dispatch(setSelectAllButtonAction(false))
    }, [dispatch]);


    const handleClick = () => {
        const newClickCount = allClickedCount + 1;
        setAllClickedCount(newClickCount);
        if(newClickCount === 1) {
            dispatch(setSelectAllButtonAction(true));
        } else if (newClickCount === 2){
            dispatch(setSelectAllButtonAction(false));
            setAllClickedCount(0);
        }
    };

    return (
        <div>
            <Tooltip placement="left" title={<h6 style={{ color: "white" }}>SelectAll</h6>}>
                <Button
                    style={{ width: 320, height: 40, backgroundColor: 'rgba(26, 26, 238, 0.54)', marginBottom: 5, marginTop: 0 }}
                    onClick={() => handleClick()}
                    variant="contained"
                    size="large"
                    color="primary"
                > Select All References </Button>
            </Tooltip>
        </div>
    );
};

export default SelectAllButton;